import { Tooltip } from "@fluentui/react-components";
import {
  ArrowSync20Regular,
  CheckmarkCircle20Regular,
  CommentError20Regular,
  DismissCircle20Regular,
  PauseCircle20Regular,
} from "@fluentui/react-icons";
import React from "react";

import { translation } from "@/i18n";
import { nsDialog } from "@/i18n/locales/dialog";
import styles from "./index.module.css";

const useTranslation = translation.use(nsDialog);

export type OperationStatus = "waiting" | "in_progress" | "success" | "failed";

export const operationStatusVisuals: {
  [key in OperationStatus]: {
    class: string;
    Icon: React.FC<React.HTMLAttributes<SVGElement>>;
  };
} = {
  waiting: {
    class: styles.waiting,
    Icon: PauseCircle20Regular,
  },
  in_progress: {
    class: styles.in_progress,
    Icon: ArrowSync20Regular,
  },
  success: {
    class: styles.success,
    Icon: CheckmarkCircle20Regular,
  },
  failed: {
    class: styles.failed,
    Icon: DismissCircle20Regular,
  },
};

export const useOperationStatusMessages = (): {
  [key in OperationStatus]: string;
} => {
  const { t } = useTranslation();

  return {
    waiting: t.dialog.operationStatus.waiting(),
    in_progress: t.dialog.operationStatus.inProgress(),
    success: t.dialog.operationStatus.success(),
    failed: t.dialog.operationStatus.failed(),
  };
};

export const OperationStatusLabel: React.FC<{
  status: OperationStatus;
  message?: string;
}> = ({ status, message }) => {
  const statusMessages = useOperationStatusMessages();
  const { class: statusClass, Icon } = operationStatusVisuals[status];
  const statusMessage = statusMessages[status];

  return (
    <div className={styles.info}>
      <div className={statusClass}>
        <div className={styles.status}>
          <Icon />

          {message ? (
            <Tooltip content={message} relationship="description">
              <div className={styles.hoverable}>
                {statusMessage}
                <CommentError20Regular />
              </div>
            </Tooltip>
          ) : (
            <div>{statusMessage}</div>
          )}
        </div>
      </div>
    </div>
  );
};
